import { Component, Input } from '@angular/core';

@Component({
  selector: 'muni-gameday-small-loading',
  templateUrl: './small-loading.template.html',
  styleUrls: ['./small-loading.styles.scss']
})
export class SmallLoadingComponent {
  @Input()
  public visible: boolean;
  @Input()
  public renderContent = false;
}
